var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagKor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_587",
    "data-name": "Ret\\xE2ngulo 587",
    width: 60,
    height: 60,
    transform: "translate(2371 3187)",
    fill: "#fff",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_506",
    "data-name": "Ret\\xE2ngulo 506",
    width: 87.284,
    height: 50.916,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag_KOR",
    transform: "translate(-2371 -3187)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag_coreiasul",
    transform: "translate(2358 3192)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_491",
    "data-name": "Ret\\xE2ngulo 491",
    width: 87.284,
    height: 68.916,
    transform: "translate(0 -9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_492",
    "data-name": "Ret\\xE2ngulo 492",
    width: 2.12,
    height: 5.833,
    transform: "matrix(0.833, -0.554, 0.554, 0.833, 56.001, 9.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7318",
    "data-name": "Caminho 7318",
    d: "M497.308,9.712l3.243,4.855-1.768,1.168-3.238-4.845Z",
    transform: "translate(-435.724 4.419)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_493",
    "data-name": "Ret\\xE2ngulo 493",
    width: 2.125,
    height: 12.733,
    transform: "matrix(0.832, -0.554, 0.554, 0.832, 58.647, 7.802)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_494",
    "data-name": "Ret\\xE2ngulo 494",
    width: 2.121,
    height: 5.84,
    transform: "translate(61.294 6.032) rotate(-33.638)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7319",
    "data-name": "Caminho 7319",
    d: "M500.949,7.289l3.233,4.855-1.762,1.179-3.233-4.855Z",
    transform: "translate(-434.066 3.317)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_495",
    "data-name": "Ret\\xE2ngulo 495",
    width: 2.122,
    height: 12.724,
    transform: "matrix(0.832, -0.555, 0.555, 0.832, 22.46, 31.929)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_496",
    "data-name": "Ret\\xE2ngulo 496",
    width: 2.12,
    height: 5.825,
    transform: "translate(19.815 33.695) rotate(-33.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_497",
    "data-name": "Ret\\xE2ngulo 497",
    width: 2.121,
    height: 5.834,
    transform: "matrix(0.832, -0.554, 0.554, 0.832, 23.639, 39.435)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_498",
    "data-name": "Ret\\xE2ngulo 498",
    width: 2.122,
    height: 12.723,
    transform: "translate(17.166 35.463) rotate(-33.685)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_499",
    "data-name": "Ret\\xE2ngulo 499",
    width: 12.728,
    height: 2.119,
    transform: "matrix(0.554, -0.832, 0.832, 0.554, 22.462, 18.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7320",
    "data-name": "Caminho 7320",
    d: "M468.049,15.148l7.06-10.6,1.763,1.179-7.058,10.6Z",
    transform: "translate(-448.236 2.071)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_500",
    "data-name": "Ret\\xE2ngulo 500",
    width: 12.739,
    height: 2.123,
    transform: "matrix(0.554, -0.832, 0.832, 0.554, 17.164, 15.462)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_501",
    "data-name": "Ret\\xE2ngulo 501",
    width: 5.825,
    height: 2.12,
    transform: "matrix(0.555, -0.832, 0.832, 0.555, 55.999, 41.336)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_502",
    "data-name": "Ret\\xE2ngulo 502",
    width: 5.842,
    height: 2.119,
    transform: "translate(59.823 35.615) rotate(-56.362)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_503",
    "data-name": "Ret\\xE2ngulo 503",
    width: 5.834,
    height: 2.126,
    transform: "translate(58.646 43.113) rotate(-56.318)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_504",
    "data-name": "Ret\\xE2ngulo 504",
    width: 5.828,
    height: 2.124,
    transform: "translate(62.471 37.363) rotate(-56.239)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_505",
    "data-name": "Ret\\xE2ngulo 505",
    width: 5.832,
    height: 2.122,
    transform: "translate(61.293 44.871) rotate(-56.251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7321",
    "data-name": "Caminho 7321",
    d: "M499.186,28.419l3.233-4.855,1.762,1.179-3.233,4.845Z",
    transform: "translate(-434.067 10.723)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_818",
    "data-name": "Grupo 818",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_817",
    "data-name": "Grupo 817",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7322",
    "data-name": "Caminho 7322",
    d: "M477.19,12.644a1.148,1.148,0,0,0-.134.214,1.6,1.6,0,0,1,.134-.214",
    transform: "translate(-444.137 5.754)",
    fill: "#b50037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7323",
    "data-name": "Caminho 7323",
    d: "M495.138,10.882a12.737,12.737,0,0,0-17.654,3.536,6.363,6.363,0,1,0,10.588,7.06,6.363,6.363,0,1,1,10.589,7.06,12.733,12.733,0,0,0-3.523-17.655",
    transform: "translate(-444.431 3.98)",
    fill: "#b50037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7324",
    "data-name": "Caminho 7324",
    d: "M477.817,12.644a6.363,6.363,0,1,0,10.588,7.06,6.364,6.364,0,1,1,10.589,7.061,12.727,12.727,0,1,1-21.177-14.121",
    transform: "translate(-444.765 5.754)",
    fill: "#1e3476"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagKor);
export default __webpack_public_path__ + "static/media/flag_KOR.bd291dd4a8b2e9e856a3d889303de754.svg";
export { ForwardRef as ReactComponent };